import { SelectOptionProps } from './select.type';

export const SelectOption = ({ value, label, ...props }: SelectOptionProps) => {
  return (
    <option value={value} label={label} {...props}>
      {label}
    </option>
  );
};
